import { z } from 'zod';
import { idSchema, timestamps } from './utility';

export const userSchema = z.object({
  id: idSchema,
  uuid: z.string(),
  name: z.string().nullable(),
  email: z.string(),
  is_banned: z.boolean(),
  is_newsletter_enabled: z.boolean(),
  is_terms_accepted: z.boolean(),
  is_privacy_accepted: z.boolean(),
  origin: z.enum(['ORGANIC']),
  last_login_at: z.string().nullable(),
  email_verified_at: z.string().nullable(),
  password: z.string().nullable(),
  '2fa_secret': z.string().nullable(),
  '2fa_session': z.string().nullable(),
  '2fa_valid_until': z.string().nullable(),
  '2fa_last_login_at': z.string().nullable(),
  remember_token: z.string().nullable(),
  ...timestamps,
});
export type User = z.infer<typeof userSchema>;

